/**
 * Created by mukund on 8/25/17.
 */

angular.module('mediacloudApp')
    .directive('batchUploader', ['$filter', '$timeout', 'FileUploader', 'UploadLimits', 'UploadErrors', 'BatchService', 'BaseFileService', 'JobService', function($filter, $timeout, FileUploader, UploadLimits, UploadErrors, BatchService, BaseFileService, JobService){
        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/upload/directives/uploader/uploader.html',
            scope: {
                errors: '=',
                account: '=',
                tracker: '=',
                batches: '=',
                cancelFile: '&',
                tenant: '='
            },
            compile: function() {
                return function(scope, element, attrs) {

                    if(scope.account) {

                        scope.userName = scope.account.login;

                        if (scope.account.firstName || scope.account.lastName) {
                            scope.userFullName = scope.account.firstName ? scope.account.firstName : "";
                            scope.userFullName += scope.account.lastName ? " " + scope.account.lastName : scope.account.lastName;
                        } else {
                            scope.userFullName = scope.userName;
                        }

                        // Default value
                        scope.contributor = scope.userName;

                        scope.$watch('tenant', function () {
                            if (scope.tenant) {
                                scope.contributor = scope.tenant.showUserFullName ? scope.userFullName : scope.userName;
                            }
                        });

                        scope.addUploader = function () {
                            scope.tracker.uploader++;
                            setShowAddBatchBtn(false);
                        };

                        scope.removeUploader = function () {
                            scope.tracker.uploader--;
                            setShowAddBatchBtn(true);
                        };

                        var setShowAddBatchBtn = function (status) {
                            scope.showAddBatchBtn = status;
                        };

                        setShowAddBatchBtn(false);

                        scope.$watch('tracker', function(){
                            if(scope.tracker && scope.tracker.uploader === 1){
                                scope.batch = {};
                                setShowAddBatchBtn(false);
                            }
                        });

                        scope.getUploader = function () {
                            // This holds all the files uploaded in a batch
                            var files = [];

                            // An instance of the file uploader which allows upload of "UploadLimits.QUEUE_SIZE" number of files at maximum
                            var uploader = new FileUploader({
                                withCredentials: true,
                                queueLimit: UploadLimits.QUEUE_SIZE,
                                url: scope.tenant.uploadUrl,
                                formData: [{userId: scope.userName}, {tenantId: scope.tenant.id}, {jwt: "12345"}],
                                filters: [
                                    {
                                        name: 'fileSize',
                                        fn: function (item) {
                                            return item.size <= UploadLimits.FILE_SIZE;
                                        }
                                    },
                                    {
                                        name: 'fileType',
                                        fn: function (item) {
                                            var fileExt = item.name.substring(item.name.lastIndexOf('.') + 1);
                                            return UploadLimits.ACCEPTED_FILE_TYPES.indexOf(fileExt.toLowerCase()) > -1;
                                        }
                                    }
                                ]
                            });

                            // This handles scenarios where the files being uploaded are not supported by ShareStream due to file size or type restrictions
                            uploader.onWhenAddingFileFailed = function (item, filter) {
                                if (filter.name === 'fileType') {
                                    scope.errors.push({
                                        id: 'ufte' + Date.now(),
                                        msg: UploadErrors.UPLOAD_FILE_TYPE.formatMessage({name: item.name})
                                    });
                                } else if (filter.name === 'fileSize') {
                                    scope.errors.push({
                                        id: 'ufze' + Date.now(),
                                        msg: UploadErrors.UPLOAD_FILE_SIZE.formatMessage({name: item.name})
                                    });
                                } else if (filter.name === 'queueLimit') {
                                    scope.errors.push({
                                        id: 'ufqle' + Date.now(),
                                        msg: UploadErrors.UPLOAD_QUEUE_SIZE.formatMessage({
                                            name: item.name,
                                            size: UploadLimits.QUEUE_SIZE
                                        })
                                    });
                                }
                            };

                            // For every file added to queue, we set the file name and file status
                            uploader.onAfterAddingFile = function (fileItem) {
                                var file = {};

                                // adopted from http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
                                // A random ID assigned to each file in a batch
                                var randomId = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                                    return v.toString(16);
                                });

                                file.name = fileItem.file.name;
                                file.randomId = randomId;
                                fileItem.file.randomId = randomId;
                                var lastDotInFilename = file.name.lastIndexOf('.');
                                file.fileNameWithoutExt = file.name.substring(0, lastDotInFilename);
                                var fileExt = file.name.substring(lastDotInFilename + 1);
                                file.needsTranscoding = !(UploadLimits.NO_TRANSCODE_FILE_TYPES.indexOf(fileExt.toLowerCase()) > -1);
                                file.uploadStatus = "File queued for upload... ";
                                file.metadata = {
                                    title: file.fileNameWithoutExt,
                                    description: "",
                                    contributor: scope.contributor
                                };
                                // Custom Profile IDs are stored here
                                file.profiles = [];
                                // This holds all errors displayed in the Metadata / Thumbnail Section
                                file.metaErrors = [];
                                // This holds all other errors displayed below the file name
                                file.errors = [];
                                file.progress = 0;
                                file.sendForCaptioning = false;
                                file.captionStatus = "";
                                // Persist the file in the 'files' array
                                files.push(file)
                            };

                            // Once all files have been added to the queue, we create a batch
                            uploader.onAfterAddingAll = function () {
                                var addBatchRequest = new BatchService.CreateBatch();
                                addBatchRequest.$save(function (batch) {

                                    scope.batch = batch;
                                    scope.batch.uploader = uploader;
                                    scope.batch.files = files;
                                    scope.batch.position = scope.tracker.uploader;
                                    scope.batch.name = "Batch " + (scope.batches.length ? scope.batches.length + 1 : scope.batch.position);

                                    scope.batch.profiles = [];
                                    scope.batch.metaErrors = [];
                                    scope.batch.errors = [];
                                    scope.batch.sendForCaptioning = false;

                                    scope.tracker.uploadingBatches++;

                                    if (scope.account.authorities.indexOf("ROLE_ADMIN") > -1) {
                                        // Allow the user to select custom profiles if he/she has Admin privileges
                                        $("#profileSettings").modal('show');
                                    } else if(scope.account.allowCaptionService && scope.tenant.captioningServiceList.length && scope.tenant.captioningServiceList.indexOf('WATSON') > -1){
                                        $('#watsonmodal').modal('show');
                                    } else {
                                        // Upload the batch using default profiles if the user is not an administrator
                                        scope.uploadBatch();
                                    }
                                }, function () {
                                    scope.errors.push({id: 'ue' + Date.now(), msg: UploadErrors.CREATE_BATCH});
                                });
                            };

                            // Before uploading each file, update its file status
                            uploader.onBeforeUploadItem = function (fileItem) {
                                var file = $filter('filter')(files, {randomId: fileItem.file.randomId}, true)[0];
                                if (file && !file.cancelled) {
                                    file.uploadStatus = "Uploading File... ";
                                    file.uploadStartTime = new Date().getTime();
                                    if (file.needsTranscoding) {
                                        fileItem.formData.push({generateThumbnail: true});
                                    } else {
                                        fileItem.formData.push({skipProcessing: true});
                                    }
                                } else {
                                    fileItem.cancel();
                                }
                            };

                            // Update the progress bar and file upload status as the file uploads
                            uploader.onProgressItem = function (fileItem, progress) {
                                var file = $filter('filter')(files, {randomId: fileItem.file.randomId}, true)[0];
                                if (file && !file.cancelled) {

                                    file.progress = progress;

                                    var totalSize = fileItem.file.size,
                                        uploadSize = (totalSize / 100) * progress,
                                        elapsedTime = new Date().getTime() - file.uploadStartTime,
                                        uploadSpeed = uploadSize / (elapsedTime / 1000),
                                        remainingTime = (totalSize - uploadSize) / uploadSpeed;

                                    if (uploadSpeed !== 0) {
                                        file.uploadStatus = "Uploading file... " + Math.floor(remainingTime / 60) + " min " + Math.ceil(remainingTime % 60) + " sec remaining";
                                    }

                                    if (progress === 100) {
                                        file.uploadStatus = "Generating thumbnail... ";
                                    }
                                } else {
                                    fileItem.cancel();
                                }
                            };

                            // If file upload fails, show an error and remove the file from the file list
                            uploader.onErrorItem = function (fileItem) {
                                scope.errors.push({
                                    id: 'ue' + Date.now(),
                                    msg: UploadErrors.UPLOAD_FILE.formatMessage({name: fileItem.file.name})
                                });
                                var file = $filter('filter')(files, {randomId: fileItem.file.randomId}, true)[0];
                                if (file && !file.cancelled) {
                                    var batch = $filter('filter')(scope.batches, {batchId: file.batchId}, true)[0];
                                    batch.errors.push({
                                        id: 'ube' + Date.now(),
                                        msg: UploadErrors.UPLOAD_FILE.formatMessage({name: fileItem.file.name})
                                    });
                                    batch.files = batch.files.filter(function (el) {
                                        return el.name !== fileItem.file.name;
                                    });
                                    batch.size = batch.files.length;
                                    if (batch.size == 0) {
                                        batch.cancelled = true;
                                    }
                                } else {
                                    fileItem.cancel();
                                }
                            };

                            // When file upload is successful, create a job for the file
                            uploader.onSuccessItem = function (fileItem, response) {
                                var file = $filter('filter')(files, {randomId: fileItem.file.randomId}, true)[0];
                                if (file && !file.cancelled) {
                                    var batch = $filter('filter')(scope.batches, {batchId: file.batchId}, true)[0];
                                    batch.uploadedFilesCnt++;
                                    var updateBaseFileRequest = {};
                                    updateBaseFileRequest.id = file.mediacloudFileId;
                                    updateBaseFileRequest.batchId = file.batchId;
                                    updateBaseFileRequest.metadata = file.metadata;
                                    updateBaseFileRequest.metadata.isStudentUpload = false;
                                    updateBaseFileRequest.fileId = response.id;
                                    if (response.thumbnails) {
                                        updateBaseFileRequest.thumbnailId = response.thumbnails[0].id;
                                    }
                                    var baseFileResource = new BaseFileService.UpdateBaseFile(updateBaseFileRequest);
                                    baseFileResource.$update(function (bfe) {
                                        file.fileId = response.id;
                                        if (response.thumbnails) {
                                            file.thumbnails = response.thumbnails;
                                            file.selectedThumbnail = response.thumbnails[0];
                                        } else {
                                            file.selectedThumbnail = {id: '000', url: 'assets/images/noThumbnail.jpg'};
                                            file.thumbnails = [];
                                            file.thumbnails.push(file.selectedThumbnail);
                                        }
                                        file.uploadComplete = true;
                                        file.uploadStatus = "Upload complete. Preparing for processing ... ";

                                        var createJobRequest = {};
                                        createJobRequest.batchId = file.batchId;
                                        createJobRequest.fileId = response.id;
                                        createJobRequest.profiles = file.profiles;
                                        createJobRequest.transcodeFile = true;
                                        createJobRequest.subtitles = [
                                            {
                                                'language': 'English',
                                                'listOrder': 1,
                                                'enabledByDefault': true
                                            }
                                        ];

                                        // Create a job for the file
                                        JobService.CreateJob().getNewJob(createJobRequest)
                                            .then(function (job) {
                                                if (job) {
                                                    file.uploadStatus = "Processing file... ";
                                                    file.jobId = job.jobId;
                                                    file.progress = 0;
                                                    file.canBePublished = true;
                                                }
                                            }, function () {
                                                batch.errors.push({
                                                    id: 'ube' + Date.now(),
                                                    msg: UploadErrors.CREATE_JOB.formatMessage({name: file.name})
                                                });
                                                scope.errors.push({
                                                    id: 'ue' + Date.now(),
                                                    msg: UploadErrors.CREATE_JOB.formatMessage({name: file.name})
                                                });
                                                // Cancel & Remove the file from the file list since this is a fatal error
                                                if (file && !file.cancelled) {
                                                    scope.cancelFile(file);
                                                } else {
                                                    fileItem.cancel();
                                                }
                                            });
                                    }, function () {
                                        batch.errors.push({
                                            id: 'ube' + Date.now(),
                                            msg: UploadErrors.UPDATE_BASEFILE.formatMessage({name: file.name})
                                        });
                                        scope.errors.push({
                                            id: 'ue' + Date.now(),
                                            msg: UploadErrors.UPDATE_BASEFILE.formatMessage({name: file.name})
                                        });
                                        // Cancel & Remove the file from the file list since this is a fatal error
                                        if (file && !file.cancelled) {
                                            scope.cancelFile(file);
                                        } else {
                                            fileItem.cancel();
                                        }
                                    });
                                } else {
                                    fileItem.cancel();
                                }
                            };

                            uploader.onCompleteAll = function () {
                                scope.tracker.uploadingBatches--;
                            };

                            return uploader;
                        };

                        // Upload the batch when the user clicks on the upload batch button
                        scope.uploadBatch = function () {

                            var batch = scope.batch;
                            // Variables which track the progress of the batch and its jobs
                            batch.progress = 0;
                            batch.uploadedFilesCnt = 0;
                            batch.transcodedCnt = 0;
                            batch.size = batch.files.length;
                            batch.uploader.queue.forEach(function (fileItem) {
                                var file = $filter('filter')(batch.files, {randomId: fileItem.file.randomId}, true)[0];
                                if (file && !file.cancelled) {
                                    file.batchId = batch.batchId;
                                    var addBaseFileRequest = {};
                                    addBaseFileRequest.batchId = batch.batchId;
                                    addBaseFileRequest.fileName = file.fileNameWithoutExt;
                                    addBaseFileRequest.autoPublish = false;
                                    addBaseFileRequest.sendForCaptioning = file.sendForCaptioning;
                                    var baseFileResource = new BaseFileService.AddBaseFile(addBaseFileRequest);
                                    baseFileResource.$save(function (baseFile) {
                                        file.mediacloudFileId = baseFile.id;
                                        file.metadata = baseFile.metadata;
                                        file.sendForCaptioning = baseFile.sendForCaptioning;
                                    }, function () {
                                        batch.errors.push({
                                            id: 'ube' + Date.now(),
                                            msg: UploadErrors.CREATE_BASEFILE.formatMessage({name: file.name})
                                        });
                                        scope.errors.push({
                                            id: 'ue' + Date.now(),
                                            msg: UploadErrors.CREATE_BASEFILE.formatMessage({name: file.name})
                                        });
                                        // Remove the file from the file list since this is a fatal error
                                        if (file && !file.cancelled) {
                                            scope.cancelFile(file);
                                        } else {
                                            fileItem.cancel();
                                        }
                                    });
                                } else {
                                    fileItem.cancel();
                                }
                            });
                            batch.uploader.uploadAll();

                            scope.batches.unshift(batch);
                            // Show a new uploader for the user to upload another batch
                            setShowAddBatchBtn(true);
                        };

                        scope.cancelNewBatch = function () {
                            if (scope.batch) {
                                BatchService.CancelBatch.erase({id: scope.batch.batchId}, function () {
                                    scope.tracker.uploadingBatches--;
                                    setShowAddBatchBtn(true);
                                }, function (error) {
                                    // TODO Check this out
                                    scope.errors.push({
                                        id: 'ue' + Date.now(),
                                        msg: "An error occurred while cancelling the batch '" + scope.batch.name + "'."
                                    });
                                });
                            }
                        };

                        scope.clickUploader = function (index) {
                            $('#input' + index).click();
                        };
                    }
                }
            }
        }
    }]);
